// extracted by mini-css-extract-plugin
module.exports = {"order":"_2OoAUI","orders":"_30v4wN","billImage":"_3pU4YD"};